import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  AppBar,
  Grid,
  Toolbar,
  IconButton,
  Typography,
  Menu,
  MenuItem,
  Button,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';

import MainLogo from '../../Assets/logos/openzklogo.png';
import ConnectButton from '../../WagmiProvider/ConnectButton';
import VestingABI from '../../ContractABI/Vesting.json';
import {
  REACT_APP_ADMIN_ROLE,
  REACT_APP_ADMIN_WHITELIST_ROLE,
  REACT_APP_FUNDS_OWNER_ROLE,
  REACT_APP_OZK_VESTING,
  REACT_APP_PRIVATE_SALE,
  REACT_APP_RPC_URL,
} from '../../Config/Config';
import Web3 from 'web3';

import {
  useAccount,
  //  useReadContract
} from 'wagmi';
import PrivateSaleABI from '../../ContractABI/OZKPrivateSale.json';

let Renderpages = [
  {
    id: 1,
    pageName: 'Presale',
    route: '/buynow',
    isSelected: false,
  },

  {
    id: 2,
    pageName: 'Dashboard',
    route: '/dashboard',
    isSelected: false,
  },
  {
    id: 3,
    pageName: 'Withdraw Admin',
    route: '/withdraw-admin',
    isSelected: false,
  },
  {
    id: 4,
    pageName: 'Whitelist Admin',
    route: '/whitelist-admin',
    isSelected: false,
  },
];

let Renderpagesuser = [
  {
    id: 1,
    pageName: 'Presale',
    route: '/buynow',
    isSelected: false,
  },
  {
    id: 2,
    pageName: 'Dashboard',
    route: '/dashboard',
    isSelected: false,
  },
  {
    id: 3,
    pageName: 'How to Claim OZK',
    route: 'https://docs.claim.openzk.net/',
    isSelected: false,
  },
];

const TopNavBar = () => {
  const navigate = useNavigate();
  const web3 = new Web3(REACT_APP_RPC_URL);

  const [anchorElNav, setAnchorElNav] = useState(null);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [Pages, setPages] = useState([]);
  const settings = ['Profile', 'Account', 'Dashboard', 'Logout'];
  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const { address, isConnected } = useAccount();

  const [currentPath, setCurrentPath] = useState('');

  useEffect(() => {
    setCurrentPath(window.location.pathname);
  }, []);

  useEffect(() => {
    if (isConnected) {
      checkHasAdminOrOwnerRole(address);
    } else {
      setPages(Renderpagesuser);
    }
  }, [isConnected, address]);

  const checkHasAdminOrOwnerRole = async (address) => {
    try {
      const PrivateSaleContract = new web3.eth.Contract(
        PrivateSaleABI,
        REACT_APP_PRIVATE_SALE,
      );
      const hasAdminRole = await PrivateSaleContract.methods
        .hasRole(REACT_APP_ADMIN_ROLE, address)
        .call();
      const hasOwnerRole = await PrivateSaleContract.methods
        .hasRole(REACT_APP_FUNDS_OWNER_ROLE, address)
        .call();
      const whiteListRole = await PrivateSaleContract.methods
        .hasRole(REACT_APP_ADMIN_WHITELIST_ROLE, address)
        .call();
      if (hasAdminRole || hasOwnerRole || whiteListRole) {
        setPages(Renderpages);
      } else {
        setPages(Renderpagesuser);
      }
    } catch (error) {
      setPages(Renderpagesuser);
    }
  };

  const hanleRoute = (i, row) => {
    navigate(row.route);
  };

  return (
    <Grid sx={{ display: 'flex' }} className="w-100" flexDirection={'column'}>
      <AppBar
        position="static"
        sx={{ backgroundColor: '#000000' }}
        className="p-3 w-100"
      >
        <Toolbar>
          <Grid
            container
            display={'flex'}
            flexDirection={'row'}
            alignItems={'center'}
            justifyContent={'space-between'}
            lg={12}
          >
            <Grid
              item
              sm={2}
              xs={4}
              display={'flex'}
              alignItems={'center'}
              justifyContent={'center'}
              onClick={() => navigate('/')}
            >
              <img
                src={MainLogo}
                alt="main_logo"
                className="img-fluid "
                style={{ cursor: 'pointer' }}
              />
              {/* </a> */}
            </Grid>

            <Grid
              xs={6.5}
              sx={{
                display: { xs: 'flex', sm: 'none' },
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <ConnectButton />

              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="inherit"
              >
                <MenuIcon />
              </IconButton>

              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{
                  display: { xs: 'block', md: 'none' },
                  '& .MuiMenu-paper': { backgroundColor: '#2a2438' },
                }}
              >
                {Pages.map((page, i) => (
                  <MenuItem
                    key={page}
                    sx={{ backgroundColor: '#2a2438' }}
                    onClick={handleCloseNavMenu}
                  >
                    {page.route.startsWith('http') ? (
                      <a
                        href={page.route}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          color:
                            currentPath == page.route ? '#FC9D4B' : '#ffffff',
                        }}
                      >
                        {page.pageName}
                      </a>
                    ) : (
                      <Typography
                        textAlign="center"
                        style={{
                          color:
                            currentPath == page.route ? '#FC9D4B' : '#ffffff',
                        }}
                        onClick={() => hanleRoute(i, page)}
                      >
                        {page.pageName
                          ? page.pageName.toUpperCase()
                          : page.pageName}
                      </Typography>
                    )}
                  </MenuItem>
                ))}
              </Menu>
            </Grid>

            <Grid
              container
              sm={6.5}
              // display={"flex"}
              flexDirection={'row'}
              alignItems={'center'}
              justifyContent={'flex-start'}
              display={{ sm: 'flex', xs: 'none' }}
            >
              {Pages?.map((page, i) => (
                <Grid item lg={2} key={i} className="mx-4">
                  {page.route.startsWith('http') ? (
                    <a
                      href={page.route}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: currentPath == page.route ? '#FC9D4B' : '#ffff',
                        border: 0,
                        display: 'block',
                        textTransform: 'none',
                        fontSize: '16px',
                        textDecoration: 'none',
                        '&:hover': {
                          textTransform: 'none !important',
                          backgroundColor: 'transparent',
                        },
                      }}
                    >
                      {page.pageName}
                    </a>
                  ) : (
                    <Button
                      key={page}
                      sx={{
                        color: currentPath == page.route ? '#FC9D4B' : '#ffff',
                        border: 0,
                        display: 'block',
                        textTransform: 'none',
                        fontSize: '16px',
                        '&:hover': {
                          textTransform: 'none',
                          backgroundColor: 'transparent',
                        },
                      }}
                      onClick={() => hanleRoute(i, page)}
                      className="border-0"
                    >
                      {page.pageName}
                    </Button>
                  )}
                </Grid>
              ))}
            </Grid>

            <Grid
              item
              sm={3}
              sx={{ flexGrow: 0 }}
              display={{ sm: 'flex', xs: 'none' }}
            >
              <div className="nav navbar-nav ms-auto ml-auto">
                <ConnectButton />
              </div>
              <Menu
                sx={{ mt: '45px' }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                {settings.map((setting) => (
                  <MenuItem key={setting} onClick={handleCloseUserMenu}>
                    <Typography textAlign="center">{setting}</Typography>
                  </MenuItem>
                ))}
              </Menu>
            </Grid>
          </Grid>
        </Toolbar>{' '}
      </AppBar>
    </Grid>
  );
};
export default TopNavBar;
